import React from "react";
//#region types
import { IncomingInvoiceProfileProps } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import { useNavigate, useLocation } from "react-router-dom";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { UrlHelper } from "utils/helpers";

const IncomingInvoiceProfile: React.FC<IncomingInvoiceProfileProps> = (props) => {
  const { id, displayText } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const onClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    navigate(UrlHelper.formatPath(`/IncomingInvoice/${id}`), {
      state: { background: location },
    });
  };

  return (
    <Grid item onClick={onClick} className={clsx(cssExports.profileLink, cssExports.truncateString)}>
      {displayText}
    </Grid>
  );
};

export default IncomingInvoiceProfile;
